import { UI_ScriptModule } from 'ui/components/2-molecules/ScriptModule/ScriptModule';

export const ScriptModuleFeature: React.FC<Content.ScriptModule> = ({ content }) => {
	return <UI_ScriptModule script={content.properties.script} />;
};
